module.exports = __webpack_public_path__ + "img/unknown.9f59d52e.png";